export default __webpack_public_path__ + "static/media/menu.54932c73.svg";